import { render, staticRenderFns } from "./SignField.vue?vue&type=template&id=73a20d3c&scoped=true"
import script from "./SignField.vue?vue&type=script&lang=js"
export * from "./SignField.vue?vue&type=script&lang=js"
import style0 from "./SignField.vue?vue&type=style&index=0&id=73a20d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a20d3c",
  null
  
)

export default component.exports